import React from 'react';

import { Selector } from '~pages/SipConfiguration/domain';

import BaseSelector from '../BaseSelector';

export default function DTMFSelector({ operation, value }: Selector) {
  return (
    <BaseSelector>
      DTMF {operation} {value}
    </BaseSelector>
  );
}
